<ng-container data-header>
    <ng-content select="[data-header]"></ng-content>
</ng-container>
<ng-container data-body>
    <ng-content select="[data-body]"></ng-content>
</ng-container>
<ng-container data-footer>
    <ng-content select="[data-footer]"></ng-content>
</ng-container>